import React from 'react';

function NoMatch() {
    return <div >
        未匹配到路由
    </div>;
}

export default NoMatch;
